
// const REGION_TO_LANG = {
//   KR: 'ko',
//   JP: 'ja',
//   ES: 'es',
//   US: 'en',
// };

// export function getLanguageFromRegion(regionCode) {
//   if (!regionCode) return 'en';
//   return REGION_TO_LANG[regionCode.toUpperCase()] || 'en';
// }

export function parseDeviceToken() {
    const token = localStorage.getItem('deviceToken');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload;
    } catch (e) {
        return null;
    } 
}

export function parseAuthToken() {    
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload;
    } catch (e) {
        return null;
    } 
}
